"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTtclidNewerInUrlThanAlreadyKnown = exports.getsTikTokIdIfKnown = exports.checkExistingTiktokId = exports.storeTikTokIds = void 0;
const ldLocalStorage_1 = require("./ldLocalStorage");
const helpers_1 = require("./helpers");
/**
 * Gets TikTok IDs and sends them back to the ldPayload object
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns {Promise<void>} fills the IDs in the payloadCallback object
 */
const storeTikTokIds = async (payloadCallback) => {
    await (0, exports.checkExistingTiktokId)(payloadCallback);
};
exports.storeTikTokIds = storeTikTokIds;
/**
 * Checks if the TikTok ID is known and fills in the information in the ldPayload
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns {Promise<string | undefined>} fills in the information in the callback
 */
const checkExistingTiktokId = async (payloadCallback) => {
    const ttpValueKnown = await (0, exports.getsTikTokIdIfKnown)("ttp");
    const ttclidValueKnown = await (0, exports.getsTikTokIdIfKnown)("ttclid");
    const ttclidValueNotNewer = !(await (0, exports.isTtclidNewerInUrlThanAlreadyKnown)());
    if (ttpValueKnown)
        payloadCallback["_ttp-clientID"] = ttpValueKnown;
    if (ttclidValueKnown && ttclidValueNotNewer)
        payloadCallback["_ttclid-clientID"] = ttclidValueKnown;
    return payloadCallback;
};
exports.checkExistingTiktokId = checkExistingTiktokId;
/**
 * Checks if TikTok ID is present in the cookie. If not, returns the value
 * from LD localStorage.
 * @param {TtCookieType} type 'ttp' or 'ttclid'
 * @returns {Promise<string | undefined>} 'ttp' or 'ttclid' value or undefined
 */
const getsTikTokIdIfKnown = (type) => {
    const getIds = () => {
        var _a;
        return (0, helpers_1.getCookieValueBasedOnName)(type) ||
            ((_a = (0, ldLocalStorage_1.getLDLocalStorage)()) === null || _a === void 0 ? void 0 : _a[`_${type}-clientID`]);
    };
    // we have to delay fetching the TikTok cookies because their tracker is slow to create them
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(getIds());
        }, 1200);
    });
};
exports.getsTikTokIdIfKnown = getsTikTokIdIfKnown;
/**
 * Check if the 'ttclid' is present in the URL and if it is a new one.
 * @returns {Promise<boolean>} true or false
 */
const isTtclidNewerInUrlThanAlreadyKnown = async () => {
    const ttclidInUrl = (0, helpers_1.getParamValueFromUrl)("ttclid");
    const ttclidValueKnown = await (0, exports.getsTikTokIdIfKnown)("ttclid");
    return ttclidValueKnown != ttclidInUrl && ttclidInUrl !== null;
};
exports.isTtclidNewerInUrlThanAlreadyKnown = isTtclidNewerInUrlThanAlreadyKnown;
